import { useLocation, Link } from 'react-router-dom';
import { List, Bell, ArrowSquareOut } from '@phosphor-icons/react';
import { useAuthStore } from '../../store/authStore';

const COMPANY_DOMAINS = {
  india: 'https://iconecc.co.in',
  uae:   'https://uae.iconecc.co.in',
  infra: 'https://iconeccinfra.ae',
};

function buildBreadcrumb(pathname) {
  const parts = pathname.replace(/^\//, '').split('/').filter(Boolean);
  return parts.map((p, i) => ({
    label: p.charAt(0).toUpperCase() + p.slice(1).replace(/-/g, ' '),
    path:  '/' + parts.slice(0, i + 1).join('/'),
  }));
}

export default function Header({ toggleSidebar }) {
  const location = useLocation();
  const { user }  = useAuthStore();
  const crumbs    = buildBreadcrumb(location.pathname);

  const companyMatch  = location.pathname.match(/\/(india|uae|infra)/);
  const activeCompany = companyMatch?.[1];

  return (
    <header
      className="flex-shrink-0 h-[60px] flex items-center justify-between px-6
                 bg-[var(--color-surface)] border-b border-[var(--color-border)] z-20"
    >
      {/* Left */}
      <div className="flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
        >
          <List size={20} />
        </button>

        {/* Breadcrumb */}
        <nav className="hidden sm:flex items-center gap-1.5 text-xs text-[var(--color-muted)]">
          <Link to="/dashboard" className="hover:text-[var(--color-text)] transition-colors">
            Admin
          </Link>
          {crumbs.map((crumb, i) => (
            <span key={crumb.path} className="flex items-center gap-1.5">
              <span>/</span>
              {i === crumbs.length - 1 ? (
                <span className="text-[var(--color-text)] font-medium capitalize">
                  {crumb.label}
                </span>
              ) : (
                <Link
                  to={crumb.path}
                  className="hover:text-[var(--color-text)] transition-colors capitalize"
                >
                  {crumb.label}
                </Link>
              )}
            </span>
          ))}
        </nav>
      </div>

      {/* Right */}
      <div className="flex items-center gap-3">
        {/* Preview current company site */}
        {activeCompany && COMPANY_DOMAINS[activeCompany] && (
          <a
            href={COMPANY_DOMAINS[activeCompany]}
            target="_blank"
            rel="noreferrer"
            className="hidden sm:flex items-center gap-1.5 text-xs text-[var(--color-muted)]
                       hover:text-[var(--color-text)] transition-colors border
                       border-[var(--color-border)] rounded-lg px-3 py-1.5"
          >
            <ArrowSquareOut size={13} />
            Preview Site
          </a>
        )}

        {/* Notifications */}
        <button className="relative text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors">
          <Bell size={18} />
          <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-[var(--color-accent)]" />
        </button>

        {/* Avatar */}
        <div
          className="w-8 h-8 rounded-full bg-[var(--color-accent)]/20 flex items-center
                      justify-center text-[var(--color-accent)] text-xs font-bold cursor-pointer"
        >
          {user?.name?.charAt(0) ?? 'A'}
        </div>
      </div>
    </header>
  );
}
